import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateFolderIcon from '@material-ui/icons/CreateNewFolder'
import CreateItemIcon from '@material-ui/icons/Add'
import DeleteItemIcon from '@material-ui/icons/DeleteForever'
import MoveToFolderIcon from '@material-ui/icons/LowPriority'

import IncomeIcon from '@material-ui/icons/AddCircle'
import OutcomeIcon from '@material-ui/icons/RemoveCircle'

import PaperBlock from "../../ui/PaperBlock"

/**
 *  <ControlPanel
 *    selected
 *    onCreateFolderClick = {selected}
 *    onCreateItemClick = {selected}
 *    onMoveToFolderClick = {selected}
 *    onDeleteItemClick = {}
 *    onIncomeClick = {item}
 *    onOutcomeClick = {item}
 *  />
 */

class ControlPanel extends Component {

  render() {
    return <PaperBlock style = {{display: "flex"}}>

      <Tooltip title = "Создать папку"><div>
        <Button
          onClick = {e => {
            e.stopPropagation()
            if (typeof this.props.onCreateFolderClick === "function") {
              this.props.onCreateFolderClick(this.props.selected)
            }
          }}
        >
          <CreateFolderIcon />
        </Button>
      </div></Tooltip>

      <Tooltip title = "Добавить предмет"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateItemClick === "function") {
							this.props.onCreateItemClick(this.props.selected)
						}
					}}
				>
					<CreateItemIcon />
				</Button>
			</div></Tooltip>

      <Tooltip title = "Переместить в папку"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onMoveToFolderClick === "function") {
							this.props.onMoveToFolderClick(this.props.selected)
						}
					}}
				>
					<MoveToFolderIcon />
				</Button>
			</div></Tooltip>

      <Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteItemClick === "function") {
							this.props.onDeleteItemClick(this.props.selected)
						}
					}}
				>
					<DeleteItemIcon />
				</Button>
			</div></Tooltip>

      <Tooltip title = "Принять"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onIncomeClick === "function") {
							this.props.onIncomeClick(this.props.selected)
						}
					}}
				>
					<IncomeIcon />
				</Button>
			</div></Tooltip>

      <Tooltip title = "Списать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onOutcomeClick === "function") {
							this.props.onOutcomeClick(this.props.selected)
						}
					}}
				>
					<OutcomeIcon />
				</Button>
			</div></Tooltip>

    </PaperBlock>
  }

}

export default ControlPanel
